import { useSelector } from 'react-redux';

export const usePreferredState = (reducer) => {
  const preferedReducer = useSelector((state) => state[reducer]);
  return preferedReducer;
};
